export default __webpack_public_path__ + "Mask-group.0f816a.svg";